export default __webpack_public_path__ + "static/viz/media/neptune.cde79dd3.svg";